export const STATE_KEY = 'STATE';
export const USER_KEY = 'USER_KEY';
export const TOKEN_KEY = 'TOKEN_KEY';
export const CONFIG_HASH = 'CONFIG_HASH';
export const ACCESS_TOKEN_EXPIRED_MESSAGE =
  'Access token has expired. please try your actions again';
export const HTTP_CODE = {
  400: 400,
  401: 401,
  403: 403,
  404: 404,
  422: 422,
  500: 500,
};

export const SORTER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const PAGINATION_DEFAULT = {
  page: 1,
  limit: 10,
};
